<template>
  <div class="footer-meta outer">
    <div class="container">
      <ul class="footer-meta__list">
        <menue v-if="context.mainmenue" :menue="context.mainmenue" :ueberschrift="'Kategorien'" />

        <menue v-if="context.verlagsmenue" :menue="context.verlagsmenue" :ueberschrift="'Verlag'" />

        <li class="footer-meta__list-item">
          Kundenservice
          <ul>
            <li class="footer-meta__list-item--level2">
              <span class="phone-number">+49 761 2717300</span>
            </li>
            <li class="footer-meta__list-item--level2">
              <a href="mailto:kundenservice@herder.de" class="footer-meta__link"
                >kundenservice@herder.de</a
              >
            </li>
            <li class="footer-meta__list-item--level2">
              <a href="https://www.herder.de/abokuendigung/" class="footer-meta__link"
                >Abo online kündigen</a
              >
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>

  <service-menue v-if="context.servicemenue" :menue="context.servicemenue" />

  <div class="footer__totop-container">
    <a href="#root" class="button button--totop">Nach oben</a>
  </div>
</template>

<script>
import Menue from './FooterMenue.vue';
import ServiceMenue from './FooterServiceMenue.vue';

export default {
  name: 'MicrositeFooter',
  props: {
    context: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  components: {
    Menue,
    ServiceMenue,
  },
};
</script>
